/**
 * Converts the provided `customBlocks` collection into a hash representation of
 * block tags to block sources. This data can be used to update RDMX components
 * or RDMD reusable content tags, which is required when parsing a document's
 * markdown body.
 */
export function createCustomBlocksHash<CustomBlocksCollection extends { source: string; tag: string }[]>(
  customBlocks: CustomBlocksCollection,
): Record<string, string> {
  return customBlocks.reduce<Record<string, string>>((acc, block) => {
    return {
      ...acc,
      [block.tag]: block.source,
    };
  }, {});
}
